import DeferredCoverageAndDocuments from "./DeferredCoverageAndDocuments";

export default DeferredCoverageAndDocuments;
